import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appConvertNumbers]',
})
export class ConvertNumbersDirective {
  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const persianToEnglishMap: { [key: string]: string } = {
      '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
      '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9',
      '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
      '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9'
    };

    if (persianToEnglishMap[event.key]) {
      event.preventDefault(); 
      const englishNumber = persianToEnglishMap[event.key];

      const inputElement = this.el.nativeElement;
      const start = inputElement.selectionStart!;
      const end = inputElement.selectionEnd!;
      const value = inputElement.value;

      inputElement.value = value.slice(0, start) + englishNumber + value.slice(end);
      inputElement.setSelectionRange(start + 1, start + 1);

      inputElement.dispatchEvent(new Event('input'));
    }
  }
}
